
export const BIOFI_STAKING_OFFERS = {
  test1: {
    StakingOfferIndex: 4,
    StakingCategory: 'Test 1',
    StakingColor: 'sandybrown',
    StakingOfferCode: 'test-1',
    MinStake: 1,
    MinStakingAmount: '1',
    MaxStakingAmount: '50,000', //5,000 in dev
    AnnualReward: '15%',
    AnnualRewardWithoutUsage: '10%',
    UtilityUsageRequirement: '2 times',
    UtilityUsagePeriod: '5 minutes',
    StakingRewards: [['Free PhenixLoc for 10 days. Go to your Dashboard', '#'], ['Access to DogeRun/Metaverse', 'https://biometricfinancial.org/providers/ethos-metaverse/']]
  },
  test2: {
    StakingOfferIndex: 5,
    StakingCategory: 'Test 2',
    StakingColor: 'sandybrown',
    StakingOfferCode: 'test-2',
    MinStake: 20000,
    MinStakingAmount: '20,000', //2,000 in dev
    MaxStakingAmount: '100,000', //10,000 in dev
    AnnualReward: '20%',
    AnnualRewardWithoutUsage: '15%',
    UtilityUsageRequirement: '4 times',
    UtilityUsagePeriod: '10 minutes',
    StakingRewards: [['Free PhenixLoc for 10 days. Go to your Dashboard', '#'], ['Access to DogeRun/Metaverse', 'https://biometricfinancial.org/providers/ethos-metaverse/']]
  },
  gold: {
    StakingOfferIndex: 0,
    StakingCategory: '⭐ Gold ⭐',
    StakingColor: 'gold',
    StakingOfferCode: 'gold',
    MinStake: 10000,
    MinStakingAmount: '10,000',
    MaxStakingAmount: '300,000',
    AnnualReward: '7%',
    AnnualRewardWithoutUsage: '5%',
    UtilityUsageRequirement: '6 times',
    UtilityUsagePeriod: '90 days',
    StakingRewards: [['Free PhenixLoc for 10 days. Go to your Dashboard', '#'], ['Access to DogeRun/Metaverse', 'https://biometricfinancial.org/providers/ethos-metaverse/']]
  },
  platinum: {
    StakingOfferIndex: 1,
    StakingCategory: '⭐⭐ Platinum ⭐⭐',
    StakingColor: 'silver',
    StakingOfferCode: 'platinum',
    MinStake: 250000,
    MinStakingAmount: '250,000',
    MaxStakingAmount: '3,000,000',
    AnnualReward: '10%',
    AnnualRewardWithoutUsage: '8%',
    UtilityUsageRequirement: '8 times',
    UtilityUsagePeriod: '120 days',
    StakingRewards: [['Free PhenixLoc for 10 days. Go to your Dashboard', '#'], ['Access to DogeRun/Metaverse', 'https://biometricfinancial.org/providers/ethos-metaverse/']]
  },
  diamond: {
    StakingOfferIndex: 2,
    StakingCategory: '⭐⭐⭐ Diamond ⭐⭐⭐',
    StakingColor: 'silver',
    StakingOfferCode: 'diamond',
    MinStake: 2950000,
    MinStakingAmount: '2,950,000',
    MaxStakingAmount: '30,000,000',
    AnnualReward: '15%',
    AnnualRewardWithoutUsage: '11%',
    UtilityUsageRequirement: '12 times',
    UtilityUsagePeriod: '180 days',
    StakingRewards: [['Free PhenixLoc for 10 days. Go to your Dashboard', '#'], ['Access to DogeRun/Metaverse', 'https://biometricfinancial.org/providers/ethos-metaverse/']]
  },
  emerald: {
    StakingOfferIndex: 3,
    StakingCategory: '⭐⭐⭐ Emerald ⭐⭐⭐',
    StakingColor: 'green',
    StakingOfferCode: 'emerald',
    MinStake: 29500000,
    MinStakingAmount: '29,500,000',
    MaxStakingAmount: '300,000,000',
    AnnualReward: '20%',
    AnnualRewardWithoutUsage: '16%',
    UtilityUsageRequirement: '24 times',
    UtilityUsagePeriod: '360 days',
    StakingRewards: [['Free PhenixLoc for 10 days. Go to your Dashboard', '#'], ['Access to DogeRun/Metaverse', 'https://biometricfinancial.org/providers/ethos-metaverse/'], ['Free access to Say-Tec API\'s', 'https://finnovant.com/say-tec/']]
  }
}


export const LP_STAKING_OFFERS = {
  maple: {
    StakingOfferIndex: 0,
    StakingCategory: 'Maple',
    StakingColor: '#B88E72',
    StakingOfferCode: 'maple',
    AnnualReward: '10%',
    AnnualRewardWithoutUsage: '10%',
    UtilityUsageRequirement: '0 times',
    UtilityUsagePeriod: '90 days',
    StakingRewards: []
  },
  oak: {
    StakingOfferIndex: 1,
    StakingCategory: 'Oak',
    StakingColor: '#D8B589',
    StakingOfferCode: 'oak',
    AnnualReward: '20%',
    AnnualRewardWithoutUsage: '20%',
    UtilityUsageRequirement: '0 times',
    UtilityUsagePeriod: '120 days',
    StakingRewards: []
  },
  mapleTest: {
    StakingOfferIndex: 2,
    StakingCategory: 'Maple test',
    StakingColor: '#B88E72',
    StakingOfferCode: 'maple',
    AnnualReward: '10%',
    AnnualRewardWithoutUsage: '10%',
    UtilityUsageRequirement: '0 times',
    UtilityUsagePeriod: '5 minutes',
    StakingRewards: []
  }
}